export default __webpack_public_path__ + "static/media/c-lead-studios-icon-01.c943256c.png";